import React, { useState } from 'react'
import { Input } from 'antd'
import PropTypes from 'prop-types'

const NumberInput = ({ value, onChange, precision, max, ...otherProps }) => {
  const [number, setNumber] = useState(null)

  const onNumberChange = changedValue => {
    let newNumber
    const dec = changedValue.indexOf('.')
    const tooLong = changedValue.length > dec + 3
    const invalidNum =
      Number.isNaN(Number(changedValue)) ||
      Number.isNaN(parseFloat(changedValue)) ||
      parseFloat(changedValue).toFixed(precision) > max
    if ((dec >= 0 && tooLong) || invalidNum) {
      newNumber = changedValue.slice(0, -1)
    } else {
      newNumber = changedValue
    }
    if (Number.isNaN(number) || Number.isNaN(newNumber)) {
      setNumber(null)
      onChange(null)
      return
    }
    if (number?.includes('.') && !changedValue?.includes('.')) {
      const [wholeNumber] = number.split('.')
      newNumber = wholeNumber
    } else if (precision === 0) {
      newNumber = Number(newNumber).toFixed(precision)
    }
    setNumber(newNumber)
    onChange(newNumber)
  }

  return (
    <Input
      type="number"
      // className={isClass ? 'new-border-style' : 'new-border-style1'}
      value={value || number}
      onChange={e => onNumberChange(e.target.value)}
      {...otherProps}
      pattern="[0-9]*"
    />
  )
}

NumberInput.propTypes = {
  precision: PropTypes.number,
  max: PropTypes.number,
}

NumberInput.defaultProps = {
  precision: 2,
  max: 10000,
}

export default NumberInput
